<template>
  <div class="dashboard-container">
    <!-- <a-row :gutter="20" class="dashboard">
      <a-col>
        <a-card :title="$t('cardTitle.howToOrderCards')" class="reset-padding style3">
          <iframe src="https://player.vimeo.com/video/558284900" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
        </a-card>
      </a-col>
    </a-row> -->
    <a-spin tip="Loading..." :spinning="isLoading" size="large">
      <div class="spin-content">
        <a-row :gutter="20" class="dashboard">
          <a-col>
            <a-card :title="`${$t('cardTitle.cardOrderForm')}`" class="style3 loading">
              <a slot="extra" class="open-instruction-video" href="#" @click.prevent="e => openInstructionVideo('https://player.vimeo.com/video/558284900')">
                <inline-svg :src="require('../../assets/images/video-capture.svg')" width="18" height="12" />
                <span>View instruction video again</span>
              </a>
              <template v-if="!isPaymentVaild && isPastor">
                <div class="text-center text-danger">
                  <p>Unfortunately, you can't order the cards.</p>
                  <p>
                    Please <router-link to="/paymentInfo" tag="a" class="text-danger text-underline">verify the payment information</router-link> and
                    <router-link to="/account" tag="a" class="text-danger text-underline">deal with the unpaid invoice</router-link>.
                  </p>
                </div>
              </template>
              <template v-else>
                <Cards
                  v-if="userCardOrder.length > 0 && !isShowCardOrder"
                  :card-items="userCardOrder"
                  @onAddNewCard="isShowCardOrder = true"
                  :data-sources="dataSources"
                  @onUpdated="doInitData"
                  @onImgSource="doGetImgSource"
                />
              </template>
              <template v-if="isShowCardOrder">
                <div>
                  <p v-if="isPastor">
                    Cards remaining on your account: <strong>{{ remainingCards }}</strong>
                  </p>
                  <Invitation ref="invitation" v-model="dataInput" @onImgSource="doGetImgSource" :data-sources="dataSources" />
                </div>
              </template>
              <CoolLightBox :items="items" :index="index" @close="index = null" :disable-zoom="true" :close-on-click-outside-mobile="true" />
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-spin>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Invitation from './Invitation';
import Cards from './Cards';
import CardOrderService from '@/services/CardOrderService';
import { groupBy, isEmpty } from 'lodash';

export default {
  components: {
    Invitation,
    Cards,
  },
  computed: {
    ...mapGetters(['user']),
    ...mapState(['settings']),
    ...mapState({
      billingInfo: state => state.payment.billingInfo,
    }),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isPaymentVaild() {
      if (!this.billingInfo) {
        return false;
      }

      const membership = this.$store.state.user.user.membership;
      return membership && ['active', 'live'].includes(membership.state);
    },
    remainingCards() {
      return this.$store.state.user.user.membership.active_cards;
    },
  },
  data: () => ({
    dataInput: {},
    items: [],
    index: null,
    imgType: '',
    userCardOrder: [],
    isShowCardOrder: false,
    isLoading: true,
    dataSources: {},
  }),
  methods: {
    ...mapActions({
      openInstructionVideo: 'openInstructionVideo',
    }),
    openLink(url, isLink = false) {
      if (isLink) {
        window.location.href = url;
      } else {
        this.$router.push({ name: url });
      }
    },
    doGetImgSource(source) {
      this.items = [
        {
          src: source.url,
          title: source.name,
        },
      ];
      this.index = 0;
    },
    async doInitData() {
      try {
        this.isLoading = true;
        if (isEmpty(this.billingInfo)) {
          await this.$store.dispatch('fetchBillingInfo');
        }
        const resp = await CardOrderService.doGetCard({ user_id: this.user.userId });
        this.userCardOrder = resp;
      } catch (error) {
        console.log({ error });
      } finally {
        this.isShowCardOrder = this.userCardOrder.length === 0;
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      const respCards = await CardOrderService.doGetCardDesigned(this.isPastor ? 'church' : 'individual-new');
      this.dataSources = {
        ...groupBy(respCards, 'cardtype'),
      };
      await this.doInitData();
    } catch (error) {
      console.log({ error });
    } finally {
      this.isShowCardOrder = this.userCardOrder.length === 0;
      this.isLoading = false;
    }
  },
};
</script>
<style lang="scss">
.open-instruction-video {
  display: flex;
  align-items: center;
  line-height: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;

  & > span {
    margin-left: 8px;
  }

  &:hover {
    color: #fff;
  }
}
.dashboard-container.content-page {
  padding: 0 !important;
  .dashboard {
    padding: 20px;
    .ant-btn {
      height: 100%;
      white-space: initial;
    }
    .loading {
      min-height: 120px;
    }
  }
  .cool-lightbox .cool-lightbox__slide .cool-lightbox__slide__img {
    width: auto;
  }
}
</style>
